module.exports = __webpack_public_path__ + "static/media/b1_levels_3-6.62be4d0c.png";